import { Controller } from "@hotwired/stimulus"
import { hideAll as hideAllPoppers } from 'tippy.js'

export default class extends Controller {
  // Only this button's own popup, so a stacked popover keeps its parent open.
  hide() {
    const instance = this.element.closest('[data-tippy-root]')?._tippy
    if (instance) {
      instance.hide()
    } else {
      hideAllPoppers()
    }
  }

  // For actions opening another surface, so nothing floats above it.
  hideAll() {
    hideAllPoppers()
  }

  // Tooltips only close on page scroll by default. In a scrolling panel their
  // anchors move under them, so close them, and cancel any still waiting on
  // their show delay, before they appear at a stale position. Coalesced to one
  // frame: a scroll fires this far faster than the panel repaints.
  hideWithin() {
    if (this.pending) return

    this.pending = requestAnimationFrame(() => {
      this.pending = null
      this.element.querySelectorAll('[data-controller~="tippy"], [data-tippy-target~="origin"]').forEach((element) => {
        if (!element._tippy) return

        element._tippy.clearDelayTimeouts()
        element._tippy.hide()
      })
    })
  }

  disconnect() {
    if (this.pending) cancelAnimationFrame(this.pending)
  }
}
